import { useRef, useEffect, useState } from 'react';
import { string, func, array, bool, any } from 'prop-types';
import './index.scss';

const SegmentedControl = ({ label, name, value, onChange, options, disabled }) => {
    const activeIndex = options.findIndex(o => o.value === value);
    const containerRef = useRef(null);
    const [indicatorStyle, setIndicatorStyle] = useState({ width: 0, translateX: 0 });
    const [ready, setReady] = useState(false);

    useEffect(() => {
        if (!containerRef.current) return;
        const buttons = containerRef.current.querySelectorAll('.segmented-control-option');
        const activeButton = buttons[activeIndex];
        if (activeButton) {
            setIndicatorStyle({
                width: activeButton.offsetWidth,
                translateX: activeButton.offsetLeft,
            });
            setReady(true);
        }
    }, [activeIndex]);

    const handleClick = (optionValue) => {
        if (!disabled) onChange({ target: { name, value: optionValue } });
    };

    return (
        <div className="segmented-control-wrapper">
            {label && <label className="form-label">{label}</label>}
            <div
                ref={containerRef}
                className={`segmented-control${disabled ? ' segmented-control--disabled' : ''}`}
            >
                <span
                    className={`segmented-control-indicator${ready ? ' segmented-control-indicator--ready' : ''}`}
                    style={{
                        width: indicatorStyle.width,
                        transform: `translateX(${indicatorStyle.translateX}px)`,
                    }}
                />
                {options.map((option) => (
                    <button
                        key={String(option.value)}
                        type="button"
                        className={`segmented-control-option${value === option.value ? ' segmented-control-option--active' : ''}`}
                        onClick={() => handleClick(option.value)}
                        disabled={disabled}
                    >
                        {option.label}
                    </button>
                ))}
            </div>
        </div>
    );
};

SegmentedControl.propTypes = {
    name: string.isRequired,
    value: any,
    onChange: func.isRequired,
    options: array.isRequired,
    label: string,
    disabled: bool,
};

SegmentedControl.defaultProps = {
    label: '',
    value: null,
    disabled: false,
};

export default SegmentedControl;
